import { render, staticRenderFns } from "./ValueConfirmation.vue?vue&type=template&id=a6b17580&"
import script from "./ValueConfirmation.vue?vue&type=script&lang=ts&"
export * from "./ValueConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports